// @ts-nocheck
/**
 * 商人システム - 商人データ定義
 */

import { MERCHANT_TYPES } from './constants';

// ========================================
// 商人一覧
// ========================================

export const MERCHANTS = {
  // ====== 一般商人 ======
  'マルクス': {
    id: 'marcus',
    name: 'マルクス',
    type: MERCHANT_TYPES.GENERAL,
    icon: '🛒',
    specialty: null, // 全属性
    appearance: 'always',
    profile: {
      appearance: '中肉中背の中年。清潔感ある商人服',
      personality: '愛想良く無難。誰にでも平等',
      speech: '「〜ですよ」「〜ございます」丁寧で標準的',
      background: '商人ギルドの中堅。手堅い商売がモットー',
    },
    greetings: [
      'いらっしゃいませ。本日も良い品を揃えておりますよ。',
      'おや、お客様。何かお探しですか？',
      'いつもご贔屓にありがとうございます。',
    ],
  },

  // ====== 属性商人 ======
  'ボルガン': {
    id: 'volgan',
    name: 'ボルガン',
    type: MERCHANT_TYPES.ATTRIBUTE,
    icon: '🔥',
    specialty: { type: 'attribute', value: '炎' },
    appearance: { weekday: 2 }, // 火曜
    profile: {
      appearance: '日焼けした筋肉質の親父。額に汗、腕まくり',
      personality: '豪快で面倒見がいい。声がでかい',
      speech: '「〜だぜ！」「〜しな！」男らしい、勢いがある',
      background: '血呪の峠出身。若い頃は冒険者だった',
    },
    greetings: [
      'おう！今日も熱い品揃えだぜ！',
      'よく来たな！炎のカードならここが一番だぜ！',
      'ガハハ！いい目してるじゃねえか！',
    ],
  },

  'クラディア': {
    id: 'claudia',
    name: 'クラディア',
    type: MERCHANT_TYPES.ATTRIBUTE,
    icon: '💧',
    specialty: { type: 'attribute', value: '水' },
    appearance: { weekday: 3 }, // 水曜
    profile: {
      appearance: '30代の姐さん。濡れた髪、貝殻のアクセサリー',
      personality: '色っぽいが商売はシビア。駆け引き上手',
      speech: '「〜かしら？」「〜してあげる」艶っぽく余裕がある',
      background: 'アクアレギナの漂流民出身。深海の知識が豊富',
    },
    greetings: [
      'あら、いらっしゃい。何かお探しかしら？',
      '水属性のカード？いいものあるわよ。',
      'ふふ、目が肥えてるわね。',
    ],
  },

  'パスト神父': {
    id: 'pastor',
    name: 'パスト神父',
    type: MERCHANT_TYPES.ATTRIBUTE,
    icon: '✨',
    specialty: { type: 'attribute', value: '光' },
    appearance: { weekday: 1 }, // 月曜
    profile: {
      appearance: '白髪の老神官。質素な法衣、穏やかな目',
      personality: '真面目で説教好き。でも根は優しい',
      speech: '「〜ですな」「〜なさい」丁寧だが説教くさい',
      background: 'ルミナリス聖域の元灯守兵。引退後に商人に',
    },
    greetings: [
      '光の導きがありますように。何をお探しですかな？',
      'おお、また会えましたな。今日も良いカードがありますぞ。',
      '正しき道を歩む者には、良き出会いがあるものです。',
    ],
  },

  'ダスカ': {
    id: 'daska',
    name: 'ダスカ',
    type: MERCHANT_TYPES.ATTRIBUTE,
    icon: '🌙',
    specialty: { type: 'attribute', value: '闇' },
    appearance: { weekday: 6 }, // 土曜
    profile: {
      appearance: 'フード被った老婆。しわだらけ、目が鋭い',
      personality: '不気味だが嘘はつかない。皮肉屋',
      speech: '「〜だよ」「〜さね」婆さん口調、含みがある',
      background: '出自不明。闇市場にも顔が利くらしい',
    },
    greetings: [
      'ひひひ...来たのかい。闇のカードが欲しいのかね？',
      '何を求めてる？...ふむ、いいカードがあるよ。',
      '目が暗闇に慣れてきたね...いい傾向さね。',
    ],
  },

  'ゴブス': {
    id: 'gobs',
    name: 'ゴブス',
    type: MERCHANT_TYPES.ATTRIBUTE,
    icon: '🌿',
    specialty: { type: 'attribute', value: '原始' },
    appearance: { weekday: 4 }, // 木曜
    profile: {
      appearance: '小柄な中年男。服に葉っぱ、泥汚れ、ボサボサ頭',
      personality: 'のんびり屋。細かいこと気にしない',
      speech: '「〜だなあ」「〜すっか」ゆるい、マイペース',
      background: '虹羽密林で育った採集者。自然に詳しい',
    },
    greetings: [
      'おー、いらっしゃいだなあ。ゆっくり見てくれよ。',
      '自然の恵みってやつは、いいもんだよなあ。',
      'まあ、急がなくていいさ。時間はたっぷりあるだろ？',
    ],
  },

  'ドクトル・ギア': {
    id: 'doctorgear',
    name: 'ドクトル・ギア',
    type: MERCHANT_TYPES.ATTRIBUTE,
    icon: '⚙️',
    specialty: { type: 'attribute', value: '未来' },
    appearance: { weekday: 5 }, // 金曜
    profile: {
      appearance: '白衣にゴーグル。髪ボサボサ、目がキラキラ',
      personality: '早口でオタク気質。自分の話に夢中',
      speech: '「〜なのだよ！」「〜というわけで」学者口調、長い',
      background: '時空旅人の末裔を自称。発明家崩れ',
    },
    greetings: [
      'おお！来たか！今日は素晴らしいカードがあるのだよ！',
      '未来の技術は素晴らしいのだ！見てくれたまえ！',
      'これはね、非常に興味深いカードでね...あ、長くなるか。',
    ],
  },

  // ====== 闇商人 ======
  '名無し': {
    id: 'nameless',
    name: '名無し',
    type: MERCHANT_TYPES.DARK,
    icon: '👻',
    specialty: null, // 全カードからランダム選択、高レアリティを割り当て
    appearance: 'random',
    profile: {
      appearance: '全身黒フード。顔見えない、囁き声',
      personality: '無口で謎めいてる。取引は正確',
      speech: '「...〜だ」「〜か？」短い、囁くような',
      background: '本名不明。高いが確実に本物を扱う',
    },
    greetings: [
      '...何が欲しい？',
      '...来たか。',
      '...見ていけ。',
    ],
  },

  // ====== 旅商人 ======
  'ゼルヴァン': {
    id: 'zelvan',
    name: 'ゼルヴァン',
    type: MERCHANT_TYPES.TRAVELER,
    icon: '🌬️',
    specialty: null, // ランダム
    appearance: 'random',
    profile: {
      appearance: '旅装束の青年。風に靡くマント、爽やか',
      personality: '陽気で自由人。どこか掴めない',
      speech: '「〜さ」「〜だろ？」軽い、飄々としてる',
      background: '各地を巡る風使い。どこから仕入れるか不明',
    },
    greetings: [
      'よう！いいもの持ってきたぜ。',
      '風の噂で聞いてきたんだけどさ、いいカードあるんだ。',
      '今日は運がいいな。掘り出し物があるぜ。',
    ],
  },

  // ====== コレクター ======
  'ピッポ': {
    id: 'pippo',
    name: 'ピッポ',
    type: MERCHANT_TYPES.COLLECTOR,
    icon: '🎭',
    specialty: { type: 'name', value: ['岩狸', '粘液獣'] },
    appearance: 'daily',
    profile: {
      appearance: '太った中年。汗っかき、興奮すると顔が赤い',
      personality: '熱狂的なマニア。推しには金を惜しまない',
      speech: '「〜なんだよ！」「〜だろ！？」興奮気味、早口',
      background: '岩狸と粘液獣に人生を捧げた男',
    },
    greetings: [
      '岩狸！！岩狸のカード持ってないか！？',
      '粘液獣もいいよな！あのプルプル感がたまらん！',
      'おお！同志か！？岩狸の良さが分かる人間は貴重だ！',
    ],
  },

  'リリアーヌ': {
    id: 'lilianne',
    name: 'リリアーヌ',
    type: MERCHANT_TYPES.COLLECTOR,
    icon: '👗',
    specialty: { type: 'name', value: ['リリカ', '魔女', 'エリザヴェット'] },
    appearance: 'daily',
    profile: {
      appearance: 'フリル服のお嬢様。巻き髪、日傘',
      personality: 'わがままだが目利き。かわいいもの狂い',
      speech: '「〜ですわ」「〜ですの」お嬢様言葉',
      background: '没落貴族の娘。カード収集で財を成した',
    },
    greetings: [
      'あら、いらっしゃい。リリカのカードはお持ち？',
      '魔女のカードも素敵ですわよね。ふふ。',
      'かわいいカードには目がないんですの。',
    ],
  },

  'ガルドス': {
    id: 'galdos',
    name: 'ガルドス',
    type: MERCHANT_TYPES.COLLECTOR,
    icon: '🐉',
    specialty: { type: 'category', value: ['ドラゴン', 'フェニックス'] },
    appearance: 'daily',
    profile: {
      appearance: '傷だらけの筋肉爺。元冒険者、片目に眼帯',
      personality: '武勇伝を語りたがる。根は優しい',
      speech: '「〜じゃ」「〜だったのう」老人口調、懐古',
      background: 'かつてドラゴンと戦った伝説の冒険者',
    },
    greetings: [
      'おお、来たか。ドラゴンのカードを見せてくれんか？',
      'フェニックスもいい...不死の炎を持つ鳥じゃ。',
      'わしも若い頃は、ドラゴンと戦ったもんじゃ...聞くか？',
    ],
  },

  'ミスティ': {
    id: 'misty',
    name: 'ミスティ',
    type: MERCHANT_TYPES.COLLECTOR,
    icon: '🐱',
    specialty: { type: 'name', value: ['ブリザードキャット', '氷猫'] },
    appearance: 'daily',
    profile: {
      appearance: '猫耳フードの女性。無表情、目だけ動く',
      personality: '猫にしか興味ない。人間には塩対応',
      speech: '「...〜」「〜だけど」短い、ぶっきらぼう',
      background: '氷結宮殿出身。猫以外どうでもいい',
    },
    greetings: [
      '...猫のカード、ある？',
      '...ブリザードキャット以外は興味ない。',
      '...まあ、見ていけば。',
    ],
  },

  'プロフ・ノーム': {
    id: 'profnome',
    name: 'プロフ・ノーム',
    type: MERCHANT_TYPES.COLLECTOR,
    icon: '🔬',
    specialty: { type: 'nameOrCategory', value: ['ゴーレム', '鴉'] },
    appearance: 'daily',
    profile: {
      appearance: '曇った眼鏡、よれた白衣。常にメモ帳',
      personality: '分析オタク。人の話聞かない',
      speech: '「〜と考えられる」「〜の観点から」論文調',
      background: '元学術都市の研究者。今は在野で研究中',
    },
    greetings: [
      'ふむ、ゴーレムのカードか。興味深いデータが取れそうだ。',
      '未来鴉の構造は非常に興味深いと考えられる。',
      'おや、来客か。まあ、研究の合間に相手をしよう。',
    ],
  },

  'シスター・エマ': {
    id: 'sisteremma',
    name: 'シスター・エマ',
    type: MERCHANT_TYPES.COLLECTOR,
    icon: '🕊️',
    specialty: { type: 'nameOrCategory', value: ['フルーツ・マリオネット', '鳥'] },
    appearance: 'daily',
    profile: {
      appearance: '修道服。柔らかい笑顔、小鳥が肩に',
      personality: '穏やかで優しい。たまに天然',
      speech: '「〜ですね」「〜ましょう」優しく柔らかい',
      background: '鳥民の島を巡礼した元修道女',
    },
    greetings: [
      'いらっしゃいませ。鳥民のカードをお探しですか？',
      'フルーツ・マリオネットも可愛らしいですよね。',
      '今日も素敵な出会いがありますように。',
    ],
  },
};

// ========================================
// 商人ID一覧
// ========================================

export const MERCHANT_IDS = Object.keys(MERCHANTS);

// ========================================
// タイプ別商人取得
// ========================================

export const getMerchantsByType = (type) => {
  return Object.values(MERCHANTS).filter(m => m.type === type);
};

// ========================================
// 属性商人一覧
// ========================================

export const ATTRIBUTE_MERCHANTS = getMerchantsByType(MERCHANT_TYPES.ATTRIBUTE);

// ========================================
// コレクター一覧
// ========================================

export const COLLECTORS = getMerchantsByType(MERCHANT_TYPES.COLLECTOR);

export default MERCHANTS;
